module.exports = __webpack_public_path__ + "img/gray_arrow.ab6879e5.svg";